// pages/PatientChatDetailPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../components/layout/DashboardLayout';
import MessageService from '../services/message.service';
import AuthService from '../services/auth.service';
import ChatHeader from '../components/chat/ChatHeader';
import BackNav from '../components/common/BackNavButton';

const PatientChatDetailPage = () => {
 const { id } = useParams();
 const [messages, setMessages] = useState([]);
 const [newMessage, setNewMessage] = useState('');
 const [doctor, setDoctor] = useState(null);

 useEffect(() => {
   loadMessages();
 }, [id]);

 const loadMessages = async () => {
   try {
     const data = await MessageService.getMessages(id);
     setMessages(data);
     if (data.length > 0 && data[0].doctor) {
       setDoctor(data[0].doctor);
     }
   } catch (error) {
     console.error('[DEBUG] Error loading messages:', error);
   }
 };

 const handleSendMessage = async (e) => {
   e.preventDefault();
   if (!newMessage.trim()) return;

   try {
     await MessageService.sendMessage(id, newMessage);
     setNewMessage('');
     loadMessages();
   } catch (error) {
     console.error('[DEBUG] Error sending message:', error);
   }
 };

 return (
   <DashboardLayout>
     <div className="h-full flex flex-col">

       <BackNav />

       {/* Header con info del professionista */}
       <ChatHeader 
          messages={messages}
          currentUserId={AuthService.getCurrentUserId()} // o come ottieni l'ID utente corrente
        />

       {/* Area messaggi */}
       <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
         {messages.map((message) => {
           const isFromDoctor = message.sender_id === 15;

           return (
             <div
               key={message.id}
               className={`mb-4 flex ${
                 isFromDoctor ? 'justify-start' : 'justify-end'
               }`}
             >
               {isFromDoctor && (
                 <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-2">
                   <span className="text-red-600 text-sm font-semibold">D</span>
                 </div>
               )}
               
               <div className="flex flex-col max-w-[70%]">
                 <div
                   className={`rounded-lg p-3 ${
                     isFromDoctor 
                       ? 'bg-red-500 text-white rounded-bl-none' 
                       : 'bg-green-500 text-white rounded-br-none'
                   }`}
                 >
                   <p>{message.content}</p>
                 </div>
                 <div 
                   className={`text-xs mt-1 text-gray-500 ${
                     isFromDoctor ? 'text-left' : 'text-right'
                   }`}
                 >
                   {new Date(message.created_at).toLocaleDateString('it-IT', {
                     hour: '2-digit',
                     minute: '2-digit',
                     day: 'numeric',
                     month: 'short'
                   })}
                 </div>
               </div>

               {!isFromDoctor && (
                 <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center ml-2">
                   <span className="text-green-600 text-sm font-semibold">P</span>
                 </div>
               )}
             </div>
           );
         })}
       </div>

       {/* Input per nuovo messaggio */}
       <form
         onSubmit={handleSendMessage}
         className="bg-white p-4 border-t flex gap-2"
       >
         <input
           type="text"
           value={newMessage}
           onChange={(e) => setNewMessage(e.target.value)}
           placeholder="Scrivi un messaggio..."
           className="flex-1 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
         />
         <button
           type="submit"
           className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
         >
           Invia
         </button>
       </form>
     </div>
   </DashboardLayout>
 );
};

export default PatientChatDetailPage;